import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Swiper, { Pagination, Autoplay } from 'swiper';
import SmallBanner from '@src/pc/index/components/SmallBanner';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';
import { Chip } from '@ifeng-fe/visualediting';
import { chipMap } from '../../chipMap';
import { formatImage } from '@ifeng-fe/public_method';
import { getThumbnail } from '@src/common/utils';

Swiper.use([Pagination, Autoplay]);

const MainNews = ({ content }) => {
    const [ swiperIndex, setSwiperIndex ] = useState(0);
    const [ videoIndex, setVideoIndex ] = useState(0);

    useEffect(() => {
        new Swiper('#swiper1', {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.pagination1'
            },
            on: {
                slideChangeTransitionEnd () {
                    setSwiperIndex(this.realIndex);
                }
            }
        });
    }, []);
    
    return (
        <div className={styles.container}>
            <div className={styles.newsListWp}>
                <Chip key="smallBanner1" {...chipMap.smallBanner1}>
                    <SmallBanner title={content.smallBanner1} />
                </Chip>

                <div className={styles.newsList}>
                    <div className={`${styles.news} ${styles.first}`}>
                        <Chip key="boldNews" {...chipMap.boldNews}>
                            <div className={styles.title}>
                                <a href={content.boldNews[0].url} target="_blank" rel="noreferrer">{content.boldNews[0].title}</a>
                            </div>
                        </Chip>

                        <Chip key="boldSubNews" {...chipMap.boldSubNews}>
                            <div>
                                {
                                    content.boldSubNews.filter((a, i) => i % 2 === 0).map((i, idx) => {
                                        return (
                                            <p key={idx}>
                                                <span><a href={content.boldSubNews[2 * idx].url} target="_blank" rel="noreferrer">{content.boldSubNews[2 * idx].title}</a></span>
                                                {
                                                    content.boldSubNews[2 * idx + 1] &&
                                                    <> | <span><a href={content.boldSubNews[2 * idx + 1].url} target="_blank" rel="noreferrer">{content.boldSubNews[2 * idx + 1].title}</a></span></>
                                                }
                                            </p>
                                        );
                                    })
                                }
                            </div>
                        </Chip>
                    </div>
                    <Chip key="newList" {...chipMap.newsList}>
                        <div>
                            {
                                content.newsList.map((data, index) => {
                                    return (
                                        <div className={styles.news} key={index}>
                                            <div className={styles.title}>
                                                <a href={data.url} target="_blank" rel="noreferrer">{data.title}</a>
                                            </div>
                                            <div>
                                                {
                                                    data.children && data.children.filter((a, i) => i % 2 === 0).map((i, idx) => {
                                                        return (
                                                            <p key={idx}>
                                                                <span><a href={data.children[2 * idx].url} target="_blank" rel="noreferrer">{data.children[2 * idx].title}</a></span>
                                                                {
                                                                    data.children[2 * idx + 1] &&
                                                                    <> | <span><a href={data.children[2 * idx + 1].url} target="_blank" rel="noreferrer">{data.children[2 * idx + 1].title}</a></span></>
                                                                }
                                                            </p>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </Chip>

                    <div className={styles.trackTitle}>
                        <Chip key="smallBanner2" {...chipMap.smallBanner2}>
                            <SmallBanner title={content.smallBanner2} />
                        </Chip>
                    </div>
                    <Chip key="track" {...chipMap.track}>
                        <div className={styles.track}>
                            {
                                content.track.filter((a, i) => i % 2 === 0).map((data, index) => {
                                    return (
                                        <p key={index}>
                                            <span><a href={content.track[2 * index].url} target="_blank" rel="noreferrer">{content.track[2 * index].title}</a></span>
                                            {
                                                content.track[2 * index + 1] &&
                                                <> | <span><a href={content.track[2 * index + 1].url} target="_blank" rel="noreferrer">{content.track[2 * index + 1].title}</a></span></>
                                            }
                                        </p>
                                    );
                                })
                            }
                        </div>
                    </Chip>

                </div>
            </div>
            <div className={styles.mediaNews}>
                <Chip key="smallBanner3" {...chipMap.smallBanner3}>
                    <SmallBanner title={content.smallBanner3} />
                </Chip>

                <div className={styles.swiperWp}>
                    <Chip key="focus" {...chipMap.focus}>
                        <div className="swiper" id="swiper1">
                            <div className="swiper-wrapper">
                                {
                                    content.focus.map((item, index) => {
                                        return (
                                            <div className="swiper-slide" key={index}>
                                                <div className={styles.swiperItem}>
                                                    <a href={item.url} target="_blank" rel="noreferrer">
                                                        <img src={formatImage(getThumbnail(item), 325 * 2, 208 * 2)} alt={item.title} />
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </Chip>

                    <div className={styles.textPart}>
                        {content.focus[swiperIndex].title}
                    </div>
                    <div className="pagination1" />
                </div>

                <Chip key="smallBanner4" {...chipMap.smallBanner4}>
                    <SmallBanner title={content.smallBanner4} />
                </Chip>

                <Chip key="videoList" {...chipMap.videoList}>
                    <div className={styles.videoWp}>
                        <div className={styles.videoTitle}>
                            {content.videoList[videoIndex].title}
                        </div>
                        <Player
                            key={videoIndex}
                            videoConfig={{
                                title: content.videoList[videoIndex].title,
                                posterUrl: getThumbnail(content.videoList[videoIndex]) || content.videoList[videoIndex].posterUrl,
                                videoPlayUrl: content.videoList[videoIndex].videoPlayUrl
                            }}
                            playermsg={{
                                // 播放器宽
                                width: 325,
                                // 播放器高
                                height: 183,
                                // 是否自动播放
                                autoPlay: false,
                                // 是否显示播放控件
                                controls: true,
                            }}
                        />
                        <div className={styles.videoList}>
                            {
                                content.videoList.map((item, index) => {
                                    return (
                                        <div key={index} onClick={() => setVideoIndex(index)}>
                                            {item.title}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </Chip>
            </div>
        </div>
    );
};

MainNews.propTypes = {
    content: PropTypes.object
};

export default MainNews;
